import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Button, Table, Container, Spinner } from 'react-bootstrap';

import { fetchAsuiteApps } from '../../../store/actions/asuiteapps/asuiteAppActions'

import PageTitle from '../../../common/PageTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

import { capitalize } from '../../../common/Utilities';

class AsuiteApps extends Component {

  componentDidMount() {
    this.props.fetchAsuiteApps();
  }
  
  renderAsuiteApps = () => {
    let asuiteapps = this.props.asuiteapps.asuiteapps;

    let asuiteappList = [];

    if (asuiteapps) {
      asuiteappList = asuiteapps.length ? (
        asuiteapps.sort(function(a,b) { return a.sequence - b.sequence } ).map((asuiteapp, key) => {

          return (
            <tr key={key}>
              <td>{asuiteapp.name}</td>
              <td>{asuiteapp.pwa_url}</td>
              <td><img alt={asuiteapp.name} src={asuiteapp.icon} /></td>
              <td className="align-center">{asuiteapp?.sequence}</td>
              <td className="align-center">{capitalize(asuiteapp?.status?.name)}</td>
              <td className="align-center">{asuiteapp.updated_at}</td>
              <td className="align-center">
                <div className="align-center action-btns">
                  <Button size="sm" className="btn-icon ml-3" onClick={(e) => {
                    e.preventDefault();
                    this.props.history.push('/asuite-apps/edit?id=' + asuiteapp.id)
                  }}>
                    <FontAwesomeIcon icon={faPen} /> Edit 
                  </Button>
                </div>
              </td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td colSpan={7}><Spinner animation="border" size="sm" /></td>
        </tr>
      )
    }
    else {
      return (
        <tr>
          <td colSpan={7}><p className="text-danger">No A-Suite Apps found.</p></td>
        </tr>
      )
    }

    return asuiteappList;
  }

  render() {
    const upsertAsuiteApp = <Button id="add-client" size="md" onClick={() => {
        this.props.history.push('/asuite-apps/new')
    }}>Add App</Button>
    

    return (
      <div>
        <Container className="waa-container">
            <PageTitle pageName="A-SUITE APPS" actionButton={upsertAsuiteApp} />
            <Row>
                <Table className="waa-table asuiteapps">
                    <thead>
                        <tr>
                            <th>APP NAME</th>
                            <th>LINK</th>
                            <th>ICON</th>
                            <th>SEQUENCE</th>
                            <th>STATUS</th>
                            <th>LAST UPDATED</th>
                            <th>ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                    { this.renderAsuiteApps() }
                  </tbody>
                </Table>
            </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  asuiteapps: state.asuiteapps,
})

const mapDispatchToProps = (dispatch) => ({
  fetchAsuiteApps: (...args) => dispatch(fetchAsuiteApps(...args))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AsuiteApps))